export default __webpack_public_path__ + "static/media/bycycle.1936a368.jpg";